export const SAVE_LANGUAGE = 'SAVE_LANGUAGE'
export const SAVE_LANGUAGE_JSON = 'SAVE_LANGUAGE_JSON'
export const GET_SUPPORTED_LANGUAGES = "GET_SUPPORTED_LANGUAGES"
export const SAVE_SUPPORTED_LANGUAGES = "SAVE_SUPPORTED_LANGUAGES"

export const saveLanguage = (language) => ({ type: SAVE_LANGUAGE, language })
export const saveLanguageJSON = (languageJSON) => ({ type: SAVE_LANGUAGE_JSON, languageJSON })
export const getSupportedLanguages = () => ({ type: GET_SUPPORTED_LANGUAGES })
export const saveSupportedLanguages = (supportedLanguages) => ({ type: SAVE_SUPPORTED_LANGUAGES, supportedLanguages })